import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { AditivosForm } from "../../modais"
import Layout from "../../Layout"
class ContratosEditForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/contratos")
  }
  render() {
    return (
      <Layout tabActive="Contratos">
        <AditivosForm isEditing={true} callBackAditivos={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(ContratosEditForm)



// WEBPACK FOOTER //
// ./src/views/contratos/aditivos/AditivosEditForm.js